<template>
	<div class="mb-5 broiler-dashboard">
		<div class="filter-bar d-flex justify-content-end align-items-center flex-wrap mb-3">
			<b-form-datepicker placeholder="From date" local="en" v-model="from_date" size="sm" class="filter-date" />
			<span class="text-muted mx-2">to</span>
			<b-form-datepicker placeholder="To date" local="en" v-model="to_date" @input="getData()" size="sm" class="filter-date" />
			<div class="user-toggle d-flex align-items-center ml-3" v-if="this.farmId === undefined">
				<feather-icon icon="UserIcon" size="15" class="mr-1 text-muted" />
				<span class="text-muted small mr-2">Select User</span>
				<label class="switch">
					<input class="user-check" type="checkbox" value="Farm" unchecked-value="User" @click="handleCheckboxClick" />
					<span class="slider round"></span>
				</label>
			</div>
		</div>

		<div v-if="infoData && infoData.length > 0">
			<div v-for="data in infoData" :key="data.id" class="farm-block mb-4">
				<div class="farm-block-header d-flex align-items-center mb-2">
					<div class="farm-badge">
						<b-img :src="require('@/assets/images/svg/hatchery/card-top.svg')" style="height: 20px; width: 20px" />
					</div>
					<div class="ml-2">
						<h5 class="mb-0 font-weight-bolder">{{ data.name }}</h5>
						<small class="text-muted">{{ data.shedCount }} sheds</small>
					</div>
				</div>

				<b-row class="match-height">
					<b-col lg="8">
						<b-row>
							<b-col md="6" xl="3" v-for="kpi in kpiList(data)" :key="kpi.label" class="mb-2">
								<div class="kpi-card">
									<span class="b-avatar rounded-circle kpi-avatar" :class="kpi.variant">
										<span class="b-avatar-custom"><b-img :src="kpi.icon" style="height: 26px; width: 26px" /></span>
									</span>
									<div class="ml-2">
										<div class="kpi-value">{{ kpi.value }}</div>
										<div class="kpi-label">{{ kpi.label }}</div>
									</div>
								</div>
							</b-col>
						</b-row>
					</b-col>

					<b-col lg="4">
						<div class="health-card h-100">
							<div class="d-flex justify-content-between align-items-center mb-1">
								<h6 class="mb-0 font-weight-bolder">Flock Health</h6>
								<b-badge
									pill
									:variant="healthScore(data) >= 80 ? 'light-success' : healthScore(data) >= 60 ? 'light-warning' : 'light-danger'"
								>
									{{ healthScore(data) >= 80 ? "Good" : healthScore(data) >= 60 ? "Fair" : "Needs Attention" }}
								</b-badge>
							</div>
							<div class="health-score">
								{{ healthScore(data) }}<span class="of100">/100</span>
							</div>
							<small class="text-muted d-block mb-2">Computed from mortality rate + FCR</small>

							<div class="shed-list">
								<div class="shed-chip" v-for="shed in data.shed" :key="shed.id" @click="shedInfo(shed.id)">
									<feather-icon icon="HomeIcon" size="14" class="mr-1 text-primary" />
									<span class="flex-grow-1">{{ shed.shed_name }}</span>
									<feather-icon icon="ChevronRightIcon" size="14" class="text-muted" />
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
			</div>
		</div>
		<div v-else>
			<b-card>
				<div class="d-flex top-header align-items-center">
					<feather-icon icon="ArrowLeftIcon" size="24" class="mr-2" @click="goBack" style="cursor: pointer" />
					<div>
						<h5>No Data Found</h5>
					</div>
				</div>
				<div class="d-flex flex-column justify-content-center align-items-center py-5">
					<b-img :src="require('@/assets/images/svg/machine/no-setter.svg')" class="mr-2" />
					<h4 class="mt-2 Secondary">There is No Farm Available</h4>
				</div>
			</b-card>
		</div>
		<b-modal
			id="user_modal"
			title="Select User"
			:no-close-on-backdrop="true"
			@ok="getData"
			@hidden="handleModalClose"
			ref="userModal"
		>
			<b-form-group>
				<template v-slot:label>User<span class="text-danger">*</span> </template>
				<div class="form-label-group">
					<validation-provider #default="{ errors }" name=" Select User" rules="required">
						<v-select v-model="formData.user_id" :options="users" label="name" clearable:false :reduce="(e) => e.id" />
						<small class="text-danger">{{ errors[0] }}</small>
					</validation-provider>
				</div>
			</b-form-group>
		</b-modal>
	</div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
	BCard,
	BCardHeader,
	BCardTitle,
	BCardText,
	BCardBody,
	BRow,
	BCol,
	BMedia,
	BMediaAside,
	BAvatar,
	BMediaBody,
	BCarousel,
	BCarouselSlide,
	BButton,
	BImg,
	BFormDatepicker,
	BFormGroup,
} from "bootstrap-vue";

import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import moment from "moment";
export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardText,
		BCardBody,
		BMedia,
		BAvatar,
		BMediaAside,
		BMediaBody,
		BButton,
		BFormDatepicker,
		BCarousel,
		BCarouselSlide,
		BImg,
		BFormGroup,
		vSelect,
	},
	data() {
		return {
			infoData: [],
			users: [],
			info: {},
			shedCount: null,
			search_filter: {
				input_field: "",
				to_date: "",
				from_date: "",
			},
			from_date: null,
			to_date: null,
			formData: {
				user_id: null,
			},
			farmId: null,
		};
	},

	created() {
		this.fromDate = moment().clone().startOf("month").format("YYYY-MM-DD");
		this.toDate = moment().clone().endOf("month").format("YYYY-MM-DD");
		this.farmId = this.$route.params.farmId;
		this.getAllUser();
		this.getData();
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		kpiList(data) {
			return [
				{ label: "No of Birds", value: data.totalBirds, icon: require("@/assets/images/dashboard/number_of_birds.svg"), variant: "badge-light-primary" },
				{ label: "Mortality Rate", value: `${data.mortalityRate} %`, icon: require("@/assets/images/dashboard/mortality.svg"), variant: "badge-light-info" },
				{ label: "Ready To Sell (Birds)", value: data.readyToSale, icon: require("@/assets/images/dashboard/ready_sell.svg"), variant: "badge-light-primary" },
				{ label: "Feed Stock", value: data.feedStock, icon: require("@/assets/images/dashboard/feed_stock.svg"), variant: "badge-light-primary" },
				{ label: "Avg Body Weight", value: data.avgBodyWeight, icon: require("@/assets/images/dashboard/average_body.svg"), variant: "badge-light-primary" },
				{ label: "Chick Placement", value: data.chickPlacement, icon: require("@/assets/images/dashboard/chick_placement.svg"), variant: "badge-light-info" },
				{ label: "FCR", value: data.FCR, icon: require("@/assets/images/dashboard/fcr.svg"), variant: "badge-light-primary" },
			];
		},
		// Simple transparent heuristic (not a backend field): lower mortality and
		// FCR closer to/below the 1.6 industry target both raise the score.
		healthScore(data) {
			const mortality = parseFloat(data.mortalityRate) || 0;
			const fcr = parseFloat(data.FCR) || 1.6;
			const mortalityScore = Math.max(0, Math.min(100, 100 - (mortality / 5) * 30));
			const fcrScore = Math.max(0, Math.min(100, 100 - Math.max(0, fcr - 1.6) * 100));
			return Math.round((mortalityScore + fcrScore) / 2);
		},
		getAllUser() {
			axiosIns
				.get(`web/users`)
				.then((response) => {
					this.users = response.data.users;
				})
				.catch((error) => {
					const data = error.response?.data?.message;
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text: data,
						},
					});
				});
		},
		getData() {
			let url = "";
			let userId = this.formData.user_id;
			let farmId = this.farmId;
			if (farmId === undefined) {
				farmId = null;
			}
			if (this.from_date != null && this.to_date != null) {
				url = `web/broiler-details?from_date=${this.from_date}&to_date=${this.to_date}&user_id=${userId}&farmId=${farmId}`;
			} else {
				url = `web/broiler-details?from_date=${this.fromDate}&to_date=${this.toDate}&user_id=${userId}&farmId=${farmId}`;
			}
			axiosIns
				.get(url)
				.then((response) => {
					this.infoData = response.data.farm_details;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		shedInfo(shedId) {
			let farmId = this.$route.params.farmId;
			if (farmId) {
				this.$router.push({
					path: `/apps/manage-farm/${farmId}/dashboard/shed/${shedId}`,
				});
			} else {
				this.$router.push({
					name: `dashboard-broiler-shed`,
					params: { shedId: `${shedId}` },
				});
			}
		},
		handleCheckboxClick() {
			const checkbox = document.querySelector(".user-check");
			const modal = this.$refs.userModal;
			if (checkbox.checked) {
				modal.show();
			} else {
				this.formData.user_id = null;
				this.getData();
			}
		},
		handleModalClose() {
			if (this.formData.user_id == null) {
				const checkbox = document.querySelector(".user-check");
				checkbox.checked = false;
			}
		},
	},
};
</script>
<style lang="scss">
.broiler-dashboard {
	.filter-bar {
		.filter-date {
			max-width: 160px;
		}
	}

	.farm-block-header {
		.farm-badge {
			width: 40px;
			height: 40px;
			border-radius: 12px;
			background: rgba(115, 103, 240, 0.12);
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.kpi-card {
		display: flex;
		align-items: center;
		background: #fff;
		border-radius: 14px;
		padding: 14px;
		height: 100%;
		box-shadow: 0 2px 10px rgba(20, 22, 43, 0.06);

		.kpi-avatar {
			width: 46px;
			height: 46px;
			flex-shrink: 0;
		}
		.kpi-value {
			font-size: 18px;
			font-weight: 700;
			line-height: 1.2;
		}
		.kpi-label {
			font-size: 12px;
			color: #6b6f8a;
			margin-top: 2px;
		}
	}

	.health-card {
		background: #fff;
		border-radius: 14px;
		padding: 18px;
		box-shadow: 0 2px 10px rgba(20, 22, 43, 0.06);

		.health-score {
			font-size: 40px;
			font-weight: 800;
			color: #7367f0;
			line-height: 1.1;

			.of100 {
				font-size: 16px;
				font-weight: 600;
				color: #6b6f8a;
			}
		}

		.shed-list {
			margin-top: 8px;

			.shed-chip {
				display: flex;
				align-items: center;
				background: #f6f7fb;
				border-radius: 10px;
				padding: 9px 12px;
				margin-bottom: 8px;
				font-size: 13px;
				cursor: pointer;
				transition: background 0.15s ease;

				&:hover {
					background: #eef0fd;
				}
			}
		}
	}
}

.show-user {
	margin: 0rem 0.5rem;
}
.shed {
	align-items: center !important;
}
.carousel-inner {
	height: 200px !important;
}
.top-header {
	border-bottom: 1px solid #296db4;
	padding: 1rem 0rem;
}
.switch {
	position: relative;
	display: inline-block;
	width: 50px;
	height: 25px;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 18px;
	width: 20px;
	left: 2px;
	bottom: 4px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input:checked + .slider {
	background-color: #2196f3;
}

input:focus + .slider {
	box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}

.shed-name:hover {
	cursor: pointer;
}
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/pages/hatchery.scss";
@import "@core/scss/vue/pages/_common.scss";
</style>
